/*
 * Parent/student exam surfaces (exam.md §10).
 *
 * These are deliberately separate from the `Exam` action types, which serve
 * the staff exam manager. The parent/student screens talk only to
 * `student-exam-surface/*`, whose endpoints resolve the acting student on the
 * server instead of trusting the `childId` the saga helper attaches to every
 * request — see the model comment in
 * `node-api/src/api/v1/models/StudentExamSurface/studentExamSurface.model.js`.
 */
export const GET_STUDENT_EXAMS = 'GET_STUDENT_EXAMS'
export const GET_STUDENT_EXAM_PERFORMANCE = 'GET_STUDENT_EXAM_PERFORMANCE'
export const GET_STUDENT_REPORT_CARDS = 'GET_STUDENT_REPORT_CARDS'
export const GET_STUDENT_REPORT_CARD_PDF = 'GET_STUDENT_REPORT_CARD_PDF'
